export default __webpack_public_path__ + "d69d3c9f428897739ed9741a01bcf5fa.gif";